import merge from "lodash/merge";
import omit from "lodash/omit";
import * as wevoTypes from "./types";
import { sessionTypes } from "../session";
import { deepCloneAndOmitAtPath } from "../../helpers/state";

const initialState = { wevoResults: {} };

function wevos(state = initialState, action) {
    switch (action.type) {
        case sessionTypes.RESET_AUTH:
            return initialState;

        case wevoTypes.REQUEST_WEVOS: {
            const boardState = {
                [action.selectedBoard.key]: {
                    fetchStatus: "loading"
                }
            };
            return Object.assign({}, state, boardState);
        }

        case wevoTypes.RECIEVE_WEVOS: {
            const { id, items, nextPageUrl } = action.board;
            const boardState = {
                [id]: {
                    items,
                    nextPageUrl,
                    fetchStatus: "loaded",
                    lastUpdate: action.recievedAt
                }
            };
            return Object.assign({}, state, boardState);
        }

        case wevoTypes.GET_WEVOS_FAILURE: {
            const { id } = action.board;
            return omit(state, [id]);
        }

        case wevoTypes.REQUEST_WEVO_RESULTS:
            return merge({}, state, {
                wevoResults: {
                    [action.wevoId]: {
                        status: "loading"
                    }
                }
            });

        case wevoTypes.WEVO_RESULTS_ERROR:
        case wevoTypes.WEVO_RESULTS_SUCCESS:
            return deepCloneAndOmitAtPath(state, [
                "wevoResults",
                action.wevoId
            ]);

        default: {
            return state;
        }
    }
}

export default wevos;



// WEBPACK FOOTER //
// ./src/modules/wevos/reducers.js